import { ExpansionConfig } from "@/types/components";
import { QualityConfig } from "@/types/domain/auction";

export const TERTIARY_STATS: string[] = ['Speed', 'Leech', 'Avoidance', 'Indestructible'] as const;

export const QUALITY_CONFIG: QualityConfig = {
  poor: { color: 'gray', order: 5 },
  common: { color: 'white', order: 4 },
  uncommon: { color: 'green', order: 3 },
  rare: { color: 'blue', order: 2 },
  epic: { color: 'purple', order: 1 },
  legendary: { color: 'orange', order: 0 },
} as const;

export const TABLE_HEADERS = [
  '',
  '',
  'Item Name',
  'Category',
  'ilvl',
  'Sell Rate',
  'Expansion',
  'Quality',
  'Extra Stats',
  'Sale Avg',
  'Sale Avg vs Buy',
  'Sell vs Buy',
  'Sell Price',
  'Sell Realm',
  'Buy Price',
  'Buy Realm',
  '',
] as const;

export const TABLE_HEADERS_HOUSING = [
  '',
  '',
  'Item Name',
  'Category',
  'Sell Rate',
  'Expansion',
  'Quality',
  'Sale Avg',
  'Sale Avg vs Buy',
  'Sell vs Buy',
  'Sell Price',
  'Sell Realm',
  'Buy Price',
  'Buy Realm',
  '',
] as const;

export const EXPANSION_MAPPING: ExpansionConfig = {
  11: 'Midnight',
  10: 'TWW',
  9: 'Dragonflight',
  8: 'Shadowlands',
  7: 'BfA',
  6: 'Legion',
  5: 'WoD',
  4: 'MoP',
  3: 'Cata',
  2: 'WotLK',
  1: 'TBC',
  0: 'Vanilla',
} as const;